// extracted by mini-css-extract-plugin
export default {"inlineStatIcon":"SBKik","divider":"_1c0SX","activeStatLabels":"_1NAH2","inactiveStatLabels":"_3HlU4","readOnly":"_3D5nO"};